var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHerodivider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 390,
    viewBox: "0 0 1440 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 121,
    fill: "#111111"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 240,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 270,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 121,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 121,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 121,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 210,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 151,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 121,
    width: 30,
    height: 30,
    fill: "#86C6FA"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 810,
    y: 151,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 181,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 180,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 121,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 151,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 121,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 240,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 121,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 210,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 151,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 151,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 180,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 151,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 270,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 210,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 179,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    y: 150,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 91,
    width: 30,
    height: 30,
    fill: "#FFACAC"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 91,
    width: 30,
    height: 30,
    fill: "#EDDCA6"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 60,
    width: 30,
    height: 30,
    fill: "#AEDFAF"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 91,
    width: 30,
    height: 30,
    fill: "#FFACAC"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 30,
    width: 30,
    height: 30,
    fill: "#EDDCA6"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 121,
    width: 30,
    height: 30,
    fill: "#EDDCA6"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 91,
    width: 30,
    height: 30,
    fill: "#FFACAC"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 121,
    width: 30,
    height: 30,
    fill: "#86C6FA"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 810,
    y: 60,
    width: 30,
    height: 30,
    fill: "#86C6FA"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 570,
    y: 30,
    width: 30,
    height: 30,
    fill: "#86C6FA"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 91,
    width: 30,
    height: 30,
    fill: "#EDDCA6"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 750,
    width: 30,
    height: 30,
    fill: "#AEDFAF"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 870,
    y: 91,
    width: 30,
    height: 30,
    fill: "#AEDFAF"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 60,
    width: 30,
    height: 30,
    fill: "#86C6FA"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 30,
    height: 30,
    fill: "#EDDCA6"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 121,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 121,
    width: 30,
    height: 30,
    fill: "#FFACAC"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 121,
    width: 30,
    height: 30,
    fill: "#AEDFAF"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 91,
    width: 30,
    height: 30,
    fill: "#EDDCA6"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 61,
    width: 30,
    height: 30,
    fill: "#86C6FA"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 91,
    width: 30,
    height: 30,
    fill: "#AEDFAF"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    y: 60,
    width: 30,
    height: 30,
    fill: "#FFACAC"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 360,
    width: 30,
    height: 30,
    fill: "#111111"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 300,
    width: 30,
    height: 30,
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerodivider);
export default __webpack_public_path__ + "static/media/hero divider.5a21237d593459cf835039bede1c9077.svg";
export { ForwardRef as ReactComponent };